<!--
 * @Description:
 * @Author: mdb
 * @Date: 2023-04-13 13:53:26
 * @LastEditTime: 2023-04-19 17:41:07
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="getList"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosFbuInterfaceRecord"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="customerName" label="来源系统">
              <CosApiSelect
                :api="getBlackReason"
                show-search
                optionFilterProp="label"
                v-model:value="queryForm.appName"
                :fieldNames="{ label: 'appName', value: 'appName' }"
              ></CosApiSelect>
            </dc-form-item>

            <dc-form-item name="customerName" label="创建时间">
              <cos-range-picker v-model:startTime="queryForm.startTime" v-model:endTime="queryForm.endTime" />
            </dc-form-item>
            <dc-form-item name="requestContent" label="请求参数">
              <a-input v-model:value="queryForm.requestContent" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="responseContent" label="结果">
              <a-input v-model:value="queryForm.responseContent" allowClear placeholder="请输入" />
            </dc-form-item>
            <div style="padding-left: 23px; padding-bottom: 12px">
              <a-checkbox v-model:checked="queryForm.valueEmpty">查询空值</a-checkbox>
            </div>
          </a-form>
        </template>
        <template #button>
          <ExportButton
            v-permission="'fbu_interface_record_export_btn'"
            appId="cos_zbu"
            taskType="104"
            :search="queryForm"
            >导出</ExportButton
          >
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, ref, computed } from 'vue'
import { externalAppLogList, getexternalAppLogList } from '@/api/marketing/marketingManage'

const tableRef = ref()
const queryForm = reactive({
  appName: undefined,
  startTime: '',
  endTime: '',
  valueEmpty: false,
  requestContent: '',
  responseContent: ''
})

const getList = (queryForm: object, callBack: (res: any) => void) => {
  externalAppLogList(queryForm).then((res) => {
    callBack(res)
  })
}
const columns = computed(() => [
  { title: '来源系统', dataIndex: 'appName' },
  { title: '创建时间', dataIndex: 'createTime' },
  { title: '请求参数', dataIndex: 'requestContent' },
  {
    title: '结果',
    dataIndex: 'responseContent'
  }
])
const getBlackReason = async () => {
  try {
    const res = await getexternalAppLogList()
    return res.data
  } catch (error) {
    console.log('getBlackReason error: ', error)
  }
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuInterfaceRecord' }
</script>

<style scoped></style>
